/* unplugin-vue-components disabled */import { render } from "./productFeatures.vue?vue&type=template&id=5617277a&scoped=true"
import script from "./productFeatures.vue?vue&type=script&lang=js"
export * from "./productFeatures.vue?vue&type=script&lang=js"

import "./productFeatures.vue?vue&type=style&index=0&id=5617277a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5617277a"]])

export default __exports__